import { getNameValuesFromEnumNames } from '@/utils/helpers';
import { CONTRACTOR_AFFILIATION_NAMES } from '@/constants/user.constants';

export const CONTRACTORS_AFFILIATION_SELECT_LIST = getNameValuesFromEnumNames(CONTRACTOR_AFFILIATION_NAMES);
